import LegalPage from '@/components/legal/LegalPage';
import { SHOP_TOS_TITLE, SHOP_TOS_LAST_UPDATED, SHOP_TOS_CONTENT } from '@/legal/tos_shop';

const TermsOfService = () => (
  <LegalPage
    title={SHOP_TOS_TITLE}
    lastUpdated={SHOP_TOS_LAST_UPDATED}
    content={SHOP_TOS_CONTENT}
  />
);

export default TermsOfService;
